"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.function.name");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.parseHTML = parseHTML;

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _from = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/from"));

var dangerousTags = ['HTML', 'STYLE', 'META', 'LINK', 'TITLE', 'BODY', 'HEAD', 'AREA', 'AUDIO', 'IMG', 'MAP', 'TRACK', 'VIDEO', 'APPLET', 'EMBED', 'IFRAME', 'NOEMBED', 'OBJECT', 'PARAM', 'PICTURE', 'SOURCE', 'CANVAS', 'NOSCRIPT', 'SCRIPT', 'BUTTON', 'DATALIST', 'FIELDSET', 'FORM', 'INPUT', 'METER', 'OPTGROUP', 'OPTION', 'OUTPUT', 'PROGRESS', 'SELECT', 'TEXTAREA', 'DETAILS', 'DIALOG', 'MENU', 'MENUITEM', 'SUMMARY', 'CONTENT', 'ELEMENT', 'SHADOW', 'SLOT', 'TEMPLATE', 'COMMAND'];
var dangerousAttributes = ['onload', 'onerror'];

function filterDangerousAttributes(element) {
  for (var _i = 0, _Array$from = (0, _from.default)(element.attributes || []); _i < _Array$from.length; _i++) {
    var attr = _Array$from[_i];

    if ((0, _includes.default)(dangerousAttributes).call(dangerousAttributes, attr.name.toLocaleLowerCase())) {
      element.removeAttribute(attr.name);
    }
  }

  return element;
}

function filterDangerousTags(element) {
  for (var _i2 = 0, _Array$from3 = (0, _from.default)(element.childNodes); _i2 < _Array$from3.length; _i2++) {
    var child = _Array$from3[_i2];

    if ((0, _includes.default)(dangerousTags).call(dangerousTags, child.nodeName)) {
      element.removeChild(child);
    } else {
      filterDangerousTags(child);
    }
  }

  return filterDangerousAttributes(element);
}

function parseHTML(content) {
  var html = document.createElement('div');
  html.innerHTML = content;
  return (0, _from.default)(filterDangerousTags(html).childNodes);
}
